import React, {useEffect, useState} from "react"
import getFileName from "../../../functions/getFileName";

function FileItem(props) {

    const removeFile = (e, index) => {
        e.preventDefault()
        const arr = [...props.value]
        arr.splice(index, 1)
        props.setValue(props.field.name, arr)
    }

    const setFile = function (e) {
        const input = e.target
            , files = [...input.files]
            , arr = []

        for (let i = 0; i < files.length; i++) {
            arr.push(files[i])
        }
        props.setValue(props.field.name, arr)
    }

    return (
        <div className={"form__item file__item " + props.classes}>
            {props.value.length > 0 ? props.value.map((val, idx) => {
                return (
                    <div className="file__item_wrap" key={idx}>
                        <a className="file-label" idx={idx} download={true}>{val.name}</a>
                        <span onClick={e => removeFile(e, idx)} className="delete-file"></span>
                    </div>
                )
            }) : ''}
            <span className="error-message">{props.error ? props.error : ''}</span>
            <label htmlFor={"add_" + props.field.name} className="add-file__btn mt-8">Загрузить</label>
            {props.field?.helpText && <p className={'file-help-text'}>{props.field?.helpText}</p>}
            <input id={"add_" + props.field.name} multiple={props.field.multiple} onChange={e => setFile(e)} className="d-none" type="file" />

            <label className="" htmlFor={props.field.name}>{props.field.label}{props.field.required || props.required ? <span>*</span> : ''}</label>
        </div>
    )
}

export default FileItem